// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1Of2r","alert":"SettungsInbox_alert__1hGTk"};